<div *transloco="let t">
	@if (finishedLoading()) {
		<div class="flex items-center justify-end gap-2 mb-2">
			<mat-form-field appearance="outline" class="w-40 tenant-unit-select" subscriptSizing="dynamic">
				<mat-label>{{ t('tenantunitDetails.details.validFrom') }}</mat-label>
				<input [matDatepicker]="dpFrom" [ngModel]="tenantUnitDateRangeFilter.validFrom" matInput disabled />
				<mat-datepicker-toggle [for]="dpFrom" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #dpFrom></mat-datepicker>
			</mat-form-field>
			<mat-form-field appearance="outline" class="w-40 tenant-unit-select" subscriptSizing="dynamic">
				<mat-label>{{ t('tenantunitDetails.details.validTo') }}</mat-label>
				<input [matDatepicker]="dpTo" [ngModel]="tenantUnitDateRangeFilter.validTo" matInput disabled />
				<mat-datepicker-toggle [for]="dpTo" matSuffix></mat-datepicker-toggle>
				<mat-datepicker #dpTo></mat-datepicker>
			</mat-form-field>
			<button mat-icon-button type="button" (click)="openDateRangeFilterDialog()" [matTooltip]="t('tenantunitDetails.dateRangeFilter.title')">
				<mat-icon [svgIcon]="icons.get('filter')"></mat-icon>
			</button>
		</div>

		<!-- Zeitstrahl Gantt mit Drag-Funktionalität -->
		<div class="gantt-section-compact">
			<ara-parameter-value-gantt
				[viewStartDate]="startDate()"
				[viewEndDate]="endDate()"
				[barTextStyle]="myBarTextStyle"
				[rowHeight]="GANTT_ROW_HEIGHT_MAIN"
				[barHeight]="GANTT_BAR_HEIGHT"
				[axisOffset]="GANTT_AXIS_OFFSET"
				axisPosition="top"
				[chartData]="timelineData"
				[showAddBtn]="false"
				[enableAxisDrag]="true"
				[disableAnimation]="isDraggingTimeline()"
				(dateRangeShift)="onDateRangeShift($event)"
				(dragStart)="onDragStart()"
				(dragEnd)="onDragEnd()"></ara-parameter-value-gantt>
		</div>

		<!-- Rollen Section -->
		<div class="section-header">
			<span class="section-title">
				<mat-icon aria-hidden="true">groups</mat-icon>
				{{ t('tenantunitDetails.roles') }}
			</span>
		</div>
		<div class="gantt-section-compact">
			<ara-parameter-value-gantt
				[viewStartDate]="startDate()"
				[viewEndDate]="endDate()"
				[barTextStyle]="myBarTextStyle"
				[rowHeight]="GANTT_ROW_HEIGHT"
				[barHeight]="GANTT_BAR_HEIGHT"
				[axisOffset]="GANTT_AXIS_OFFSET"
				axisPosition="none"
				[chartData]="rolesData()"
				[showAddBtn]="false"
				[disableAnimation]="isDraggingTimeline()"></ara-parameter-value-gantt>
		</div>

		<!-- Nutzeranteile Section -->
		<!-- Bearbeitungsmöglichkeiten (showAddBtn, rowActionClick, ganttSegmentClick) absichtlich deaktiviert. -->
		<div class="section-header">
			<span class="section-title">
				<mat-icon aria-hidden="true">pie_chart</mat-icon>
				{{ t('tenantunitDetails.shares') }}
			</span>
		</div>
		<div class="gantt-section-compact">
			<ara-parameter-value-gantt
				[viewStartDate]="startDate()"
				[viewEndDate]="endDate()"
				[barTextStyle]="myBarTextStyle"
				[rowHeight]="GANTT_ROW_HEIGHT"
				[barHeight]="GANTT_BAR_HEIGHT"
				[axisOffset]="GANTT_AXIS_OFFSET"
				axisPosition="none"
				[chartData]="basicShareData()"
				[showAddBtn]="false"
				[disableAnimation]="isDraggingTimeline()"></ara-parameter-value-gantt>
		</div>
	}
</div>
